import { Routes, Route } from 'react-router-dom';
import { useAuth } from './hooks/useAuth';
import { Layout } from './components/layout/Layout';
import { HomePage } from './components/pages/HomePage';
import { LoginPage } from './components/pages/LoginPage';
import { RegisterPage } from './components/pages/RegisterPage';
import { ForgotPasswordPage } from './components/pages/ForgotPasswordPage';
import { ResetPasswordPage } from './components/pages/ResetPasswordPage';
import { DashboardPage } from './components/pages/DashboardPage';
import { ImpressumPage } from './components/pages/ImpressumPage';
import { DatenschutzPage } from './components/pages/DatenschutzPage';
import { AGBPage } from './components/pages/AGBPage';
import { CompliancePage } from './components/pages/CompliancePage';
import { VerfahrenPage } from './components/pages/VerfahrenPage';
import { KontaktPage } from './components/pages/KontaktPage';
import { AuctionLandingPage } from './components/auction/AuctionLandingPage';
import { BidPage } from './components/auction/BidPage';
import { BidHistoryPage } from './components/auction/BidHistoryPage';
import { ProfilePage } from './components/pages/ProfilePage';
import { ProfileDocumentsPage } from './components/pages/ProfileDocumentsPage';
import { AdminDashboardPage } from './components/admin/AdminDashboardPage';
import { AdminAuctionsPage } from './components/admin/AdminAuctionsPage';
import { AdminAuctionDetailPage } from './components/admin/AdminAuctionDetailPage';
import { AdminAuctionAnalyticsPage } from './components/admin/AdminAuctionAnalyticsPage';
import { AdminUsersPage } from './components/admin/AdminUsersPage';
import { AdminInvitationsPage } from './components/admin/AdminInvitationsPage';
import { AdminZuschlaegePage } from './components/admin/AdminZuschlaegePage';
import { AdminAnfragenPage } from './components/admin/AdminAnfragenPage';
import { AdminProtokollePage } from './components/admin/AdminProtokollePage';
import { NotFoundPage } from './components/pages/NotFoundPage';
import { AuthCallback } from './components/pages/AuthCallback';
import { Patent11914489Landing } from './components/pages/Patent11914489Page';
import { UnsubscribePage } from './components/pages/UnsubscribePage';

function App() {
  const { user, profile, isAdmin } = useAuth();

  return (
    <Routes>
      {/* Public */}
      <Route path="/" element={<Layout><HomePage /></Layout>} />
      <Route path="/patent/11914489" element={<Patent11914489Landing />} />
      <Route path="/verfahren" element={<Layout><VerfahrenPage /></Layout>} />
      <Route path="/impressum" element={<Layout><ImpressumPage /></Layout>} />
      <Route path="/datenschutz" element={<Layout><DatenschutzPage /></Layout>} />
      <Route path="/agb" element={<Layout><AGBPage /></Layout>} />
      <Route path="/compliance" element={<Layout><CompliancePage /></Layout>} />
      <Route path="/kontakt" element={<Layout><KontaktPage /></Layout>} />
      <Route path="/unsubscribe" element={<UnsubscribePage />} />
      <Route path="/anmelden" element={<Layout><LoginPage /></Layout>} />
      <Route path="/registrieren" element={<Layout><RegisterPage /></Layout>} />
      <Route path="/passwort-vergessen" element={<Layout><ForgotPasswordPage /></Layout>} />
      <Route path="/passwort-zuruecksetzen" element={<Layout><ResetPasswordPage /></Layout>} />
      <Route path="/auth/callback" element={<Layout><AuthCallback /></Layout>} />

      {/* Protected: Bidder */}
      <Route path="/dashboard" element={user ? <Layout><DashboardPage /></Layout> : <LoginPage />} />
      <Route path="/auktion/:aktenzeichen" element={user ? <Layout><AuctionLandingPage /></Layout> : <LoginPage />} />
      <Route path="/auktion/:aktenzeichen/bieten" element={user ? <Layout><BidPage /></Layout> : <LoginPage />} />
      <Route path="/auktion/:aktenzeichen/historie" element={user ? <Layout><BidHistoryPage /></Layout> : <LoginPage />} />
      <Route path="/profil" element={user ? <Layout><ProfilePage /></Layout> : <LoginPage />} />
      <Route path="/profil/dokumente" element={user ? <Layout><ProfileDocumentsPage /></Layout> : <LoginPage />} />

      {/* Protected: Admin */}
      <Route path="/admin" element={isAdmin ? <Layout><AdminDashboardPage /></Layout> : <NotFoundPage />} />
      <Route path="/admin/auktionen" element={isAdmin ? <Layout><AdminAuctionsPage /></Layout> : <NotFoundPage />} />
      <Route path="/admin/auktionen/:aktenzeichen" element={isAdmin ? <Layout><AdminAuctionDetailPage /></Layout> : <NotFoundPage />} />
      <Route path="/admin/auktionen/:aktenzeichen/analytics" element={isAdmin ? <Layout><AdminAuctionAnalyticsPage /></Layout> : <NotFoundPage />} />
      <Route path="/admin/nutzer" element={isAdmin ? <Layout><AdminUsersPage /></Layout> : <NotFoundPage />} />
      <Route path="/admin/einladungen" element={isAdmin ? <Layout><AdminInvitationsPage /></Layout> : <NotFoundPage />} />
      <Route path="/admin/zuschlaege" element={isAdmin ? <Layout><AdminZuschlaegePage /></Layout> : <NotFoundPage />} />
      <Route path="/admin/anfragen" element={isAdmin ? <Layout><AdminAnfragenPage /></Layout> : <NotFoundPage />} />
      <Route path="/admin/protokolle" element={isAdmin ? <Layout><AdminProtokollePage /></Layout> : <NotFoundPage />} />

      {/* 404 */}
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}

export default App;
